module.exports = __webpack_public_path__ + "assets/img/memory_leak_event.d9d99617.jpg";